import { LocaleLink as Link } from '../i18n/locale-link';
import { useT } from '../i18n/locale-context';
import { COMPANY } from '../lib/company';
import { ContactSupport } from './contact-support';

/** Public site footer with legal + company links. Rendered at the foot of the
 * scrollable content area in the app shell. */
export function Footer() {
  const t = useT();
  const year = new Date().getFullYear();

  const links: Array<{ to: string; label: string }> = [
    // First, and sitewide on purpose. /directory is the only internal path to the
    // 31 category and 14 region hubs — 43 of those 45 were orphaned before it
    // existed (see routes/public/directory.tsx). The footer renders on every
    // prerendered page, so this one static link puts every hub two hops from
    // anywhere. It is a fixed route, not fetched data, so it cannot render empty.
    { to: '/directory', label: t('footer.directory') },
    { to: '/about', label: t('footer.about') },
    { to: '/guide', label: t('footer.guide') },
    { to: '/plans', label: t('footer.plans') },
    { to: '/offer', label: t('footer.offer') },
    { to: '/privacy', label: t('footer.privacy') },
    { to: '/requisites', label: t('footer.requisites') },
  ];

  return (
    <footer className="mt-10 border-t border-edge-light pt-6 text-[12.5px] text-ink-muted">
      <nav className="mb-3 flex flex-wrap items-center gap-x-5 gap-y-2">
        {links.map((l) => (
          <Link key={l.to} to={l.to} className="font-medium transition-colors hover:text-brand">
            {l.label}
          </Link>
        ))}
        {/* Support opens the contact modal (not a route), styled to match the links. */}
        <ContactSupport className="font-medium transition-colors hover:text-brand">
          {t('footer.support')}
        </ContactSupport>
      </nav>
      <p className="leading-[1.6]">
        © {year} {COMPANY.legalName}. {t('footer.rights')}
        <br />
        {t('footer.inn')}: {COMPANY.inn}
      </p>
    </footer>
  );
}
